// @flow

import { useState, type Node } from 'react'

type Props = {
    size?: number,
    current?: number,
    children: ({
        size: number,
        current: number,
        setStop: (number) => void,
    }) => Node,
}

const Stops = ({ size, children, current }: Props) => {
    const [stop, setStop] = useState(current !== undefined ? current : Stops.defaultProps.current)

    return children({
        size: size || Stops.defaultProps.size,
        current: stop,
        setStop,
    })
}

Stops.defaultProps = {
    current: 1,
    size: 3,
}

export default Stops
